(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('OrganoRelevanteSearch', OrganoRelevanteSearch);

    OrganoRelevanteSearch.$inject = ['$resource'];

    function OrganoRelevanteSearch($resource) {
        var resourceUrl =  'api/_search/organo-relevantes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
